import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dots-dark",
  "use": "icon-dots-dark-usage",
  "viewBox": "0 0 23 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 23 5\" id=\"icon-dots-dark\">\n<style type=\"text/css\">\n\t#icon-dots-dark .st0{fill:#666666;}\n</style>\n<circle id=\"icon-dots-dark_Oval\" class=\"st0\" cx=\"20.5\" cy=\"2.5\" r=\"2.5\" />\n<circle id=\"icon-dots-dark_Oval_1_\" class=\"st0\" cx=\"11.5\" cy=\"2.5\" r=\"2.5\" />\n<circle id=\"icon-dots-dark_Oval_2_\" class=\"st0\" cx=\"2.5\" cy=\"2.5\" r=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol